import { NavList } from "../shared";

function AllerganProAppList() {
    const appList = [
        { url: "/allergan-pro/forms", name: "Forms" },
        { url: "/allergan-pro/tier", name: "Tier Progress" },
    ];

    return <NavList backUrl="/" title="Allergan Pro Configurations" navList={appList} />;
}

export default AllerganProAppList;
